import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { postData } from "../../../utility/Utility"; // adjust path
// import CustomLoader from "../../../Components/CustomLoader/CustomLoader";
import { postData } from "../../../../utility/Utility";
import CustomLoader from "../../../../Components/CustomLoader/CustomLoader";

function CommissionList() {
  const navigate = useNavigate();
  const [commissions, setCommissions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState();
  const [pageCount, setPageCount] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const rowsPerPage = 10;

  // Fetch commissions
  const fetchCommissions = async (page = 0) => {
    setLoading(true);
    try {
      const response = await postData("api/refer-commission/list", {
        page: page + 1, // 1-based index for API
        limit: rowsPerPage,
      });

      if (response?.success) {
        setCommissions(response?.data || []);
        setTotalItems(response?.pagination?.totalItems || 0);
        setPageCount(response?.pagination?.totalPages || 0);
      } else {
        toast.error(response?.message || "Failed to fetch commissions");
      }
    } catch (error) {
      console.error("Fetch commissions error:", error);
      toast.error("Error fetching commissions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCommissions(currentPage);
  }, [currentPage]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  return (
    <div className="content-page">
      <ToastContainer position="top-right" autoClose={3000} />
      <CustomLoader loading={loading} />

      <div className="content">
        <div className="container-fluid">
          {/* Header Section */}
          <div className="py-3 d-flex align-items-sm-center flex-sm-row flex-column justify-content-between">
            <div className="flex-grow-1">
              <h4 className="fs-18 fw-semibold m-0">Commission List</h4>
            </div>
            <div>
              <button
                className="btn btn-primary"
                onClick={() => navigate("/add-commission")}
              >
                <i className="mdi mdi-plus me-1"></i>
                Create Commission
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="row mt-2">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  {loading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Category ID</th>
                            <th>SubCategory ID</th>
                            <th>Total Levels</th>
                            <th>Created At</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                      <tbody>
  {commissions.length > 0 ? (
    commissions.map((commission, index) => (
      <tr key={commission._id}>
        <td>{currentPage * rowsPerPage + index + 1}</td>
        
        {/* Category title */}
        <td>{commission.categoryId?.title || "N/A"}</td>
        
        {/* Subcategory title */}
        <td>{commission.subCategoryId?.title || "N/A"}</td>
        
        {/* Total levels */}
        <td>{commission.levels?.length || 0}</td>
        
        {/* Show all levels as tooltip or inline */}
        <td>
          {commission.levels?.map((lvl, i) => (
            <div key={lvl._id}>
              L{i + 1}: {lvl.percentage}% ({lvl.requiredAgents} agents)
            </div>
          ))}
        </td>
        
        {/* Created At (fallback if missing) */}
        <td>
          {commission.createdAt
            ? new Date(commission.createdAt).toLocaleDateString()
            : "-"}
        </td>
        
        <td>
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm btn-outline-info"
              onClick={() =>
                navigate(`/commission-details`, { state: { commission } })
              }
            >
              <i className="mdi mdi-eye"></i>
            </button>
          </div>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7" className="text-center py-4">
        No commissions found
      </td>
    </tr>
  )}
</tbody>

                      </table>

                      {/* Pagination */}
                      {pageCount > 1 && (
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            Showing {currentPage * rowsPerPage + 1} to{" "}
                            {Math.min((currentPage + 1) * rowsPerPage, totalItems)} of{" "}
                            {totalItems} entries
                          </div>
                          <ReactPaginate
                            previousLabel={<i className="mdi mdi-chevron-left"></i>}
                            nextLabel={<i className="mdi mdi-chevron-right"></i>}
                            breakLabel="..."
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageChange}
                            containerClassName="pagination pagination-rounded justify-content-end mt-3"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            activeClassName="active"
                            forcePage={currentPage}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommissionList;
